import React from "react";
import homeIcon from "../../assets/images/icons/userTherapistPage/home.svg";
import therapyPlannerIcon from "../../assets/images/icons/userTherapistPage/therapyPlanner.svg";
import bankIcon from "../../assets/images/icons/userTherapistPage/bank.svg";
import settingsIcon from "../../assets/images/icons/userTherapistPage/settings.svg";
import testIcon from "../../assets/images/adminHome/tests.svg";
import supportsIcon from "../../assets/images/adminHome/supports.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { logoutUser } from "../../redux/authSlice";
import { FiFileText, FiCalendar, FiTag } from "react-icons/fi";

function AdminSideBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/");
  };

  return (
    <div className="w-full md:w-auto">
      {/* Sidebar */}
      <aside className="bg-background w-full md:w-[260px] rounded-[12px] md:rounded-[20px] mt-4 md:mt-10 mb-6 md:mb-10 shadow-lg md:sticky md:top-8">
        <nav className="overflow-x-auto max-w-full">
          <ul className="flex md:flex-col items-center md:items-start gap-2 md:gap-5 px-3 md:px-4 py-3 text-[#5F5F5F] font-poppins text-[12px] md:text-[18px] whitespace-nowrap">
            <li
              className={`flex items-center gap-1.5 md:gap-2 px-1.5 py-1 md:px-2 rounded-md hover:text-text hover:bg-white/70 cursor-pointer transition-colors ${isActive("/adminHome") ? "bg-white/70 text-text font-semibold" : ""}`}
              onClick={() => navigate("/adminHome")}
            >
              <img src={homeIcon} alt="Home" className="w-4 h-4 md:w-6 md:h-6" />
              {t("home")}
            </li>

            <li
              className={`flex items-center gap-1.5 md:gap-2 px-1.5 py-1 md:px-2 rounded-md hover:text-text hover:bg-white/70 cursor-pointer transition-colors ${isActive("/adminTherapistInfo") ? "bg-white/70 text-text font-semibold" : ""}`}
              onClick={() => navigate("/adminTherapistInfo")}
            >
              <img src={therapyPlannerIcon} alt="Therapists" className="w-4 h-4 md:w-6 md:h-6" />
              {t("therapists")}
            </li>

            <li
              className={`flex items-center gap-1.5 md:gap-2 px-1.5 py-1 md:px-2 rounded-md hover:text-text hover:bg-white/70 cursor-pointer transition-colors ${isActive("/adminSurveys") ? "bg-white/70 text-text font-semibold" : ""}`}
              onClick={() => navigate("/adminSurveys")}
            >
              <img src={testIcon} alt="Surveys" className="w-4 h-4 md:w-6 md:h-6" />
              Surveys
            </li>

            <li
              className={`flex items-center gap-1.5 md:gap-2 px-1.5 py-1 md:px-2 rounded-md hover:text-text hover:bg-white/70 cursor-pointer transition-colors ${isActive("/adminTests") ? "bg-white/70 text-text font-semibold" : ""}`}
              onClick={() => navigate("/adminTests")}
            >
              <img src={testIcon} alt="Tests" className="w-4 h-4 md:w-6 md:h-6" />
              {t("tests")}
            </li>

            <li
              className={`flex items-center gap-1.5 md:gap-2 px-1.5 py-1 md:px-2 rounded-md hover:text-text hover:bg-white/70 cursor-pointer transition-colors ${isActive("/adminBlog") ? "bg-white/70 text-text font-semibold" : ""}`}
              onClick={() => navigate("/adminBlog")}
            >
              <FiFileText className="w-4 h-4 md:w-6 md:h-6" />
              Blog
            </li>

            <li
              className={`flex items-center gap-1.5 md:gap-2 px-1.5 py-1 md:px-2 rounded-md hover:text-text hover:bg-white/70 cursor-pointer transition-colors ${isActive("/adminSupports") ? "bg-white/70 text-text font-semibold" : ""}`}
              onClick={() => navigate("/adminSupports")}
            >
              <img src={supportsIcon} alt="Supports" className="w-4 h-4 md:w-6 md:h-6" />
              {t("support")}
            </li>

            <li
              className={`flex items-center gap-1.5 md:gap-2 px-1.5 py-1 md:px-2 rounded-md hover:text-text hover:bg-white/70 cursor-pointer transition-colors ${isActive("/adminSessions") ? "bg-white/70 text-text font-semibold" : ""}`}
              onClick={() => navigate("/adminSessions")}
            >
              <FiCalendar className="w-4 h-4 md:w-6 md:h-6" />
              Sessions
            </li>

            <li
              className={`flex items-center gap-1.5 md:gap-2 px-1.5 py-1 md:px-2 rounded-md hover:text-text hover:bg-white/70 cursor-pointer transition-colors ${isActive("/adminCoupons") ? "bg-white/70 text-text font-semibold" : ""}`}
              onClick={() => navigate("/adminCoupons")}
            >
              <FiTag className="w-4 h-4 md:w-6 md:h-6" />
              Coupons
            </li>

            <li
              className={`flex items-center gap-1.5 md:gap-2 px-1.5 py-1 md:px-2 rounded-md hover:text-text hover:bg-white/70 cursor-pointer transition-colors ${isActive("/adminPayment") ? "bg-white/70 text-text font-semibold" : ""}`}
              onClick={() => navigate("/adminPayment")}
            >
              <img src={bankIcon} alt="Bank" className="w-4 h-4 md:w-6 md:h-6" />
              {t("bank")}
            </li>

            <li
              className={`flex items-center gap-1.5 md:gap-2 px-1.5 py-1 md:px-2 rounded-md hover:text-text hover:bg-white/70 cursor-pointer transition-colors ${isActive("/adminSettings") ? "bg-white/70 text-text font-semibold" : ""}`}
              onClick={() => navigate("/adminSettings")}
            >
              <img src={settingsIcon} alt="Settings" className="w-4 h-4 md:w-6 md:h-6" />
              {t("settings")}
            </li>

            <li
              className="flex items-center gap-1.5 md:gap-2 px-1.5 py-1 md:px-2 rounded-md text-red-600 hover:text-red-700 hover:bg-white/70 cursor-pointer font-semibold transition-colors"
              onClick={handleLogout}
            >
              Logout
            </li>
          </ul>
        </nav>
      </aside>
    </div>
  );
}

export default AdminSideBar;
